import React from 'react';
import {LocalFireDepartmentRounded, MultilineChartRounded, SportsEsportsRounded} from '@mui/icons-material';
import BlockIcon from './BlockIcon';
import ReviewItemCard from './ReviewItemCard';

const TYPE_ICONS = {
    scorcher: <BlockIcon outlined icon={<LocalFireDepartmentRounded />} />,
    game:     <BlockIcon outlined icon={<SportsEsportsRounded />} />,
    desmos:   <BlockIcon outlined icon={<MultilineChartRounded />} />,
};

const InteractiveCard = ({id, title, selected, onToggle, typePill, previewButton, onPreview}) => (
    <ReviewItemCard
        id={id}
        text={title}
        checked={selected}
        onToggle={onToggle}
        icon={typePill ? TYPE_ICONS[typePill.toLowerCase()] : undefined}
        tags={typePill ? [{label: typePill, variant: typePill.toLowerCase()}] : undefined}
        onPreview={previewButton ? onPreview : undefined}
    />
);

export default InteractiveCard;
